import React from 'react';
import { FormattedMessage } from 'react-intl';

export const speakerList = [
  {
    image: './img/speakerAvatar@1x/photo@1x.png',
    webPage:
      'https://www.ualberta.ca/science/about-us/about-our-dean/index.html',
    name: <FormattedMessage id="speackerName" />,
    date: <FormattedMessage id="speackerDate" />,
    subject: <FormattedMessage id="speackerSubject" />,
    description: <FormattedMessage id="speackerDesription" />
  },
  {
    image: './img/speakerAvatar@1x/photo4@1x.png',
    name: <FormattedMessage id="speackerName4" />,
    date: <FormattedMessage id="speackerDate4" />,
    subject: <FormattedMessage id="speackerSubject4" />,
    description: <FormattedMessage id="speackerDesription4" />
  },
  {
    image: './img/speakerAvatar@1x/photo11@1x.png',
    name: <FormattedMessage id="speackerName11" />,
    date: <FormattedMessage id="speackerDate11" />,
    subject: <FormattedMessage id="speackerSubject11" />,
    description: <FormattedMessage id="speackerDesription11" />
  },
  {
    image: './img/speakerAvatar@1x/photo8@1x.png',
    name: <FormattedMessage id="speackerName6" />,
    date: <FormattedMessage id="speackerDate6" />,
    subject: <FormattedMessage id="speackerSubject6" />,
    description: <FormattedMessage id="speackerDesription6" />
  },
  {
    image: './img/speakerAvatar@1x/photo5@1x.png',
    name: <FormattedMessage id="speackerName5" />,
    date: <FormattedMessage id="speackerDate5" />,
    subject: <FormattedMessage id="speackerSubject5" />,
    description: <FormattedMessage id="speackerDesription5" />
  },
  {
    image: './img/speakerAvatar@1x/photo7@1x.png',
    name: <FormattedMessage id="speackerName8" />,
    date: <FormattedMessage id="speackerDate8" />,
    subject: <FormattedMessage id="speackerSubject8" />,
    description: <FormattedMessage id="speackerDesription8" />
  },
  {
    image: './img/speakerAvatar@1x/photo10@1x.png',
    name: <FormattedMessage id="speackerName10" />,
    date: <FormattedMessage id="speackerDate10" />,
    subject: <FormattedMessage id="speackerSubject10" />,
    description: <FormattedMessage id="speackerDesription10" />
  },
  {},
  {
    image: './img/speakerAvatar@1x/photo3@1x.png',
    name: <FormattedMessage id="speackerName3" />,
    date: <FormattedMessage id="speackerDate3" />,
    subject: <FormattedMessage id="speackerSubject3" />,
    description: <FormattedMessage id="speackerDesription3" />
  },
  {},
  {
    image: './img/speakerAvatar@1x/photo6@1x.png',
    name: <FormattedMessage id="speackerName7" />,
    date: <FormattedMessage id="speackerDate7" />,
    subject: <FormattedMessage id="speackerSubject7" />,
    description: <FormattedMessage id="speackerDesription7" />
  },
  {
    image: './img/speakerAvatar@1x/photo9@1x.png',
    name: <FormattedMessage id="speackerName9" />,
    date: <FormattedMessage id="speackerDate9" />,
    subject: <FormattedMessage id="speackerSubject9" />,
    description: <FormattedMessage id="speackerDesription9" />
  },
  {
    image: './img/speakerAvatar@1x/photo2@1x.png',
    name: <FormattedMessage id="speackerName2" />,
    date: <FormattedMessage id="speackerDate2" />,
    subject: <FormattedMessage id="speackerSubject2" />,
    description: <FormattedMessage id="speackerDesription2" />
  },
  {
    image: './img/speakerAvatar@1x/photo1@1x.png',
    name: <FormattedMessage id="speackerName1" />,
    date: <FormattedMessage id="speackerDate1" />,
    subject: <FormattedMessage id="speackerSubject1" />,
    description: <FormattedMessage id="speackerDesription1" />
  },
  {
    image: './img/speakerAvatar@1x/photo12@1x.png',
    name: <FormattedMessage id="speackerName12" />,
    date: <FormattedMessage id="speackerDate12" />,
    subject: <FormattedMessage id="speackerSubject12" />,
    description: <FormattedMessage id="speackerDesription12" />
  },
  {
    image: './img/speakerAvatar@1x/photo13@1x.png',
    name: <FormattedMessage id="speackerName13" />,
    date: <FormattedMessage id="speackerDate13" />,
    subject: <FormattedMessage id="speackerSubject13" />,
    description: <FormattedMessage id="speackerDesription13" />
  }
];
